import { combineReducers } from 'redux';

import profile from './profile/profileReducer';

export default combineReducers({
	profile,
});
